import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import { Button, ButtonSizeTypes, ButtonStyleTypes } from '../../Button';
import { wizardActionCreators } from '../state';
export var WizardButtonDefaultProps = {};
export var WizardButtonTypes;

(function (WizardButtonTypes) {
  WizardButtonTypes["Next"] = "Next";
  WizardButtonTypes["Previous"] = "Previous";
  WizardButtonTypes["Finish"] = "Finish";
})(WizardButtonTypes || (WizardButtonTypes = {}));

var wizardButtonOnClickFunctions = {
  Next: function Next() {
    return wizardActionCreators.incrementStep();
  },
  Previous: function Previous() {
    return wizardActionCreators.decrementStep();
  },
  Finish: function Finish() {
    /* Put any action to be called for finish here.*/
  }
};
export function createWizardButton(wizardButtonType, styleType, sizeType) {
  var WizardButtonBase = function WizardButtonBase(props) {
    var ButtonBase = Button[styleType][sizeType];

    var composedOnClick = function composedOnClick(event) {
      wizardButtonOnClickFunctions[wizardButtonType]();
      if (props.onClick) props.onClick(event);
    };

    return React.createElement(ButtonBase, Object.assign({}, props, {
      onClick: composedOnClick
    }));
  };

  WizardButtonBase.defaultProps = WizardButtonDefaultProps;
  return WizardButtonBase;
}

function createWizardButtons() {
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(WizardButtonTypes).map(function (wizardButtonType) {
    return _defineProperty({}, wizardButtonType, generateButtonsByStyle(wizardButtonType));
  }))));
}

function generateButtonsByStyle(wizardButtonType) {
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(ButtonStyleTypes).map(function (styleType) {
    return _defineProperty({}, styleType, generateButtonsBySize(styleType, wizardButtonType));
  }))));
}

function generateButtonsBySize(styleType, wizardButtonType) {
  var DefaultButton = createWizardButton(wizardButtonType, styleType, ButtonSizeTypes.Default);
  return Object.assign.apply(Object, [DefaultButton].concat(_toConsumableArray(Object.keys(ButtonSizeTypes).map(function (sizeType) {
    return _defineProperty({}, sizeType, createWizardButton(wizardButtonType, styleType, sizeType));
  }))));
}

export var WizardButton = createWizardButtons();